import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";

const CommitteeForm = {
  committeeName: "",
};
// create slice
const name = "reports";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const reportActions = { ...slice.actions, ...extraActions };
export const reportReducer = slice.reducer;

function createInitialState() {
  return {
    membershipReportList: {},
    loginReportList: {},
  };
}

function createReducers() {
  return {
    resetMembershipReport,
    resetLoginReport,
  };

  function resetMembershipReport(state, action) {
    state.membershipReportList = {};
  }

  function resetLoginReport(state, action) {
    state.loginReportList = {};
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    getMembershipReport: getMembershipReport(),
    getLoginReport: getLoginReport(),
    userMigration: userMigration(),
  };

  /* get Membership Report */
  function getMembershipReport() {
    return createAsyncThunk(
      `${name}/getMembershipReport`,
      async ({ params, payload }) =>
        await fetchWrapper.post(
          `${baseUrl}/report/membershipReportList${params}`,
          payload
        )
    );
  }
  /* get login Report */
  function getLoginReport() {
    return createAsyncThunk(
      `${name}/getLoginReport`,
      async ({ params, payload }) =>
        await fetchWrapper.post(
          `${baseUrl}/report/loginReportList${params}`,
          payload
        )
    );
  }
  /* user Migration */
  function userMigration() {
    return createAsyncThunk(
      `${name}/userMigration`,
      async () => await fetchWrapper.get(`${baseUrl}/report/userMigration`)
    );
  }
}

function createExtraReducers(builder) {
  builder

    //membership report list
    .addCase(extraActions.getMembershipReport.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getMembershipReport.fulfilled, (state, action) => {
      const params = action.meta.arg;
      if (params?.payload?.isExport) {
        state.membershipReportListForExport = action?.payload;
      } else {
        state.membershipReportList = action?.payload;
      }
      state.loading = false;
    })
    .addCase(extraActions.getMembershipReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //Login Report
    .addCase(extraActions.getLoginReport.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getLoginReport.fulfilled, (state, action) => {
      const params = action.meta.arg;
      console.log(params, "ss");
      if (params?.payload?.isExport) {
        state.loginReportListForExport = action?.payload;
      } else {
        state.loginReportList = action?.payload;
      }
      state.loading = false;
    })
    .addCase(extraActions.getLoginReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    })

    //user Migration
    .addCase(extraActions.userMigration.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.userMigration.fulfilled, (state, action) => {
      state.userMigrationData = action?.payload;
      state.loading = false;
    })
    .addCase(extraActions.userMigration.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
      showToastNotification(action.error.message, "error");
    });
}
